import React from 'react'

import { wwwUrl } from 'frontend_core/dist/helpers/url'

/**
 * 規約の同意に関するコンポーネント
 * ※ 全体的なstyleが難解すぎるのでstyled-components化はしていません
 */
export const SignUpFormAgree = ({ children }) => (
  <div className="col-sm-12 clear">
    <p className="signup-box__wrapper-form-notes">
      本サービスのご利用には、
      <a href={wwwUrl('/about/terms')} target="_blank">スペースマーケット利用規約</a>
      ・
      <a href={wwwUrl('/about/terms_of_space_use')} target="_blank">ゲスト規約</a>
      ・
      <a href={wwwUrl('/about/privacy')} target="_blank">プライバシーポリシー</a>
      に同意していただく必要があります。
    </p>
    {children}
  </div>
)
